import { render, staticRenderFns } from "./rmHspa.vue?vue&type=template&id=2124b6be"
import script from "./rmHspa.vue?vue&type=script&lang=js"
export * from "./rmHspa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports